import { Canvas, Edge, EdgeData, ElkRoot, NodeData } from "reaflow";
import { CustomLabel, CustomNode } from "../components/flow/components/graphs";
import { TaskStatus } from "../types";
import { getFlowTheme } from "../components/flow/theme";

import { useWorkflowProcessor } from "utils/useWorkflowProcessor";
import { MouseEvent, useRef, useState } from "react";

const dashedEdgeStyles = {
  stroke: "#b1b1b7",
  strokeDasharray: "5",
  strokeDashoffset: 10,
  strokeWidth: 1,
  markerEnd: "none",
};

interface WorkflowVisualizerProps {
  data: Record<string, unknown>; // The JSON input
  executionMode?: boolean; // The type input
  onClick?: (e: MouseEvent<HTMLElement>, data: NodeData) => void;
  zoom?: number;
  zoomable?: boolean;
  pannable?: boolean;
  maxHeightOverride?: boolean;
  maxWidthOverride?: boolean;
  subWorkflowFetcher?: () => Promise<any>;
}

function WorkflowVisualizer({
  data,
  executionMode = false,
  onClick,
  zoom,
  zoomable,
  pannable,
  maxHeightOverride,
  maxWidthOverride,
  subWorkflowFetcher,
}: // onClick,
WorkflowVisualizerProps) {
  const canvasRef = useRef(null);
  const [layout, setLayout] = useState<ElkRoot>();
  const { nodes, edges } = useWorkflowProcessor(
    data,
    executionMode,
    subWorkflowFetcher
  );
  const theme = getFlowTheme("light");
  const [zoomVal, setZoomVal] = useState(0.75);
  const heightT = layout?.height ? layout?.height * zoomVal : 0;

  return (
    <div>
      <div>
        {!!nodes && !!edges ? (
          <Canvas
            ref={canvasRef}
            {...(maxHeightOverride && { maxHeight: heightT })}
            {...(pannable ? { pannable: true } : { pannable: false })}
            {...(zoomable ? { zoomable: true } : { zoomable: false })}
            {...(zoom && { zoom: zoom })}
            {...(maxWidthOverride && { maxWidth: layout?.width })}
            animated={true}
            fit={false}
            nodes={nodes}
            edges={edges}
            layoutOptions={{
              "org.eclipse.elk.spacing.edgeEdge": "170",
              "org.eclipse.elk.padding":
                "[top=10,left=100,bottom=10,right=100]",
              "org.eclipse.elk.layered.edgeLabels.centerLabelPlacementStrategy":
                "SPACE_EFFICIENT_LAYER",
            }}
            edge={(edge: EdgeData) => {
              const edgeStylesForTaskStatus = [
                TaskStatus.COMPLETED,
                TaskStatus.COMPLETED_WITH_ERRORS,
              ].includes(edge?.data?.status)
                ? {
                    stroke: theme.edges.completed.stroke,
                    strokeWidth: theme.edges.completed.strokeWidth,
                  }
                : {
                    stroke: theme.edges.default.stroke,
                    strokeWidth: theme.edges.default.strokeWidth,
                  };
              const edgeStyles =
                edge?.data?.unreachableEdge === true
                  ? dashedEdgeStyles
                  : edgeStylesForTaskStatus;
              return (
                <Edge
                  selectable={false}
                  label={<CustomLabel nodes={nodes} selectEdge={() => null} />}
                  style={edgeStyles}
                />
              );
            }}
            node={
              <CustomNode
                onClick={onClick}
                actions={null}
                onToggleTaskMenu={() => null}
                onDeleteBranch={() => null}
                isInconsistent={false}
              />
            }
            onLayoutChange={(layout) => {
              if (layout != null && layout?.width != null) {
                setLayout(layout);
              }
            }}
            onZoomChange={(zoomValue) => {
              if (zoomable) {
                setZoomVal(zoomValue);
              }
            }}
          />
        ) : null}
      </div>
    </div>
  );
}

export default WorkflowVisualizer;
